const LAUNCH_PROMPT_SEEN_PREFIX = 'guidance-tour:dealer-onboarding:launch-prompt-seen:';

const buildKey = (dealerId: string): string =>
  `${LAUNCH_PROMPT_SEEN_PREFIX}${dealerId}`;

export const hasSeenOnboardingLaunchPrompt = (dealerId: string): boolean => {
  if (!dealerId) return true;
  try {
    return localStorage.getItem(buildKey(dealerId)) === 'true';
  } catch {
    return false;
  }
};

export const markOnboardingLaunchPromptSeen = (dealerId: string): void => {
  if (!dealerId) return;
  try {
    localStorage.setItem(buildKey(dealerId), 'true');
  } catch {
    // ignore storage failures
  }
};

export const clearOnboardingLaunchPromptSeen = (dealerId: string): void => {
  if (!dealerId) return;
  try {
    localStorage.removeItem(buildKey(dealerId));
  } catch {
    // ignore storage failures
  }
};
